import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import TurmaTableSelectRedux from '../Turma/TurmaTableSelectRedux';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TurmaProfileRedux from '../Turma/TurmaProfileRedux';
import AlunoTurmaTable from './AlunoTurmaTable';
import { useSelector } from 'react-redux';
import AlunoTurmaFormContainer from './AlunoTurmaFormContainer';
import { Grid } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ADMIN, COORDENADOR } from '../Usuario/Perfil';
import { confirmAlert } from 'react-confirm-alert';
import { gerarResultadoFinalPorTurma } from './api-aluno-turma';
import { errorMessage, successMessage } from '../../util/ConfirmAlertUtil';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    title: {
        marginBottom: '20px'
    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    }

});

export default function AlunoTurmaContainer() {
    const classes = useStyles();
    const turma = useSelector(state => state.turma);
    const alunoTurma = useSelector(state => state.alunoTurma);
    const [anchorEl, setAnchorEl] = useState(null);
    const user = useSelector(state => state.usuario);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleGerarResultadoFinal = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Gerar Resultado Final para a Turma?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        gerarResultadoFinalPorTurma(turma.getCodigo).then((data) => {
                            if(data){
                                if(data.error){
                                    errorMessage(data.message);
                                }else{
                                    successMessage("Operação sendo realizada em segundo plano. ")
                                }
                            }
                        })

                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }

    return (
        <div>
            <Container className={classes.paper} component={Paper}>


                {turma ?
                    <>
                        <Grid container justifyContent="space-between">
                            <Grid size={3}>
                                <Typography className={classes.title} variant="h6">
                                    Alunos Turma
                                </Typography>
                            </Grid>
                            <Grid style={{ flexBasis: '5%' }} size={3}>
                                {user.perfil === ADMIN || user.perfil === COORDENADOR ?
                                    <>
                                        <MenuIcon
                                            fontSize='small'
                                            className={classes.cursorLink}
                                            onClick={(event) => handleMenuClick(event)}
                                            color="secondary"
                                        />
                                        <Menu
                                            id="simple-menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleMenuClose}
                                        >
                                            <MenuItem onClick={handleGerarResultadoFinal}>
                                                Gerar Resultado Final
                                            </MenuItem>


                                        </Menu>
                                    </> : ''}
                            </Grid>
                        </Grid>
                        <TurmaProfileRedux />
                        {alunoTurma ?
                            <AlunoTurmaFormContainer /> :
                            <AlunoTurmaTable />}

                    </>
                    :
                    <>
                        <Typography className={classes.title} variant="h6">
                            Alunos Turma
                        </Typography>

                        <TurmaTableSelectRedux />

                    </>
                }

            </Container>

        </div>
    );
}